import { SkillsCardProps } from "../types/skillscard.type";
//@ts-ignore
import '../assets/style/skillscard.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToolTip from "./ToolTip";
import { useEffect, useRef, useState } from "react";

const SkillsCard:React.FC<SkillsCardProps> = ({icon, text, active, bgColor, tooltip, skillsData, setSkillsData, ...props}) => {
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const skillsRef = useRef<HTMLDivElement>(null);
    useEffect(()=>{
        if(!skillsRef.current) return;
        const skillsElem = skillsRef.current as HTMLElement;
        const tooltip:HTMLElement =  (skillsElem.childNodes[0] as HTMLElement);
        const observer = new IntersectionObserver((entries)=>{
            if(entries[0].isIntersecting){
                if(tooltip.classList.contains('tooltip')){
                    if(active){
                        tooltip?.classList.add('visible');
                        setIsHovered(true);
                    }else{
                        tooltip?.classList.remove('visible');
                        setIsHovered(false);
                    }
                }else{
                    tooltip?.classList.remove('visible');
                    setIsHovered(false);    
                }
            }else{
                tooltip?.classList.remove('visible');
                setIsHovered(false);      
            }
        },{
            threshold: 0.5,
        });
        observer.observe(skillsElem);

        return ()=>{
            observer.disconnect();
        }
    }, [active]);
    return (
        <div 
            ref={skillsRef}
            className={`skills-card${active ? ' active' : ''}`} 
            onMouseEnter={(e)=> {
                e.stopPropagation()
                if(!active){
                    setIsHovered(true)
                }
                if(bgColor){
                    (e.currentTarget as HTMLElement).style.backgroundColor = bgColor;
                }
            }}
            onMouseLeave={(e)=> {
                e.stopPropagation()
                if(!active)
                setIsHovered(false)
                if(bgColor){
                    (e.currentTarget as HTMLElement).style.backgroundColor = "var(--white)";
                }
            }}
            {...props}>
            {
                tooltip &&
                <ToolTip 
                    title={{
                        icon: tooltip?.title.icon,
                        text: tooltip?.title.text
                    }}
                    skillsData={skillsData}
                    active={active}
                    setSkillsData={setSkillsData}
                    isHovered={isHovered}
                    setIsHovered={setIsHovered}
                    description={tooltip.description}/>
            }
            {icon && <FontAwesomeIcon icon={icon} style={{marginBottom: '-1px', fontSize: '15px', marginRight: '4px'}}/>}
            {text}
        </div>
    );
}
export default SkillsCard;